import { graphql, useStaticQuery } from "gatsby";
import React from "react";
import CookieConsent from "react-cookie-consent";

export const CookieBanner: React.FC = () => {
  const data = useStaticQuery(graphql`
    query CookieBanner {
      strapiGlobalContent {
        cookie_statement {
          data {
            childrenMarkdownRemark {
              html
            }
          }
        }
      }
    }
  `);
  return (
    <CookieConsent
      cookieName="limaCookies"
      containerClasses="bg-light-gray fixed b-0 flex left-[-1px] right-[-1px] justify-between content-center px-8 py-6 border border-b-none border-purple rounded-2xl rounded-b-none"
      contentClasses="text-purple flex  flex-wrap"
      buttonClasses="flex bg-green h-12 cursor-pointer items-center justify-center rounded-2xl border border-purple px-5 py-1 text-m  w-36"
      declineButtonClasses="flex  h-12 cursor-pointer items-center justify-center rounded-2xl border border-purple px-5 py-1 text-m bg-purple text-white mb-4 w-36"
      enableDeclineButton={true}
      disableStyles={true}
      declineButtonText="Reject"
      buttonText="Accept"
      onAccept={() => {
        window.location.reload();
      }}
    >
      {data.strapiGlobalContent?.cookie_statement?.data?.childrenMarkdownRemark?.map(
        (item, i) => (
          <div
            className="markdown "
            key={`cookie-content-${i}`}
            dangerouslySetInnerHTML={{ __html: item?.html || "" }}
          />
        ),
      )}
    </CookieConsent>
  );
};
